<template>
	<div class="tips-modal">
		<div class="tips-modal-head">
			<span>{{modalTitle}}</span>
			<i class="el-icon-close" @click="hideModal"></i>
		</div>
		<div class="tips-modal-body">
			<img src="../../assets/common/icons/modalIcon.png" />
			<span>{{modalContent}}</span>
		</div>
		<div class="tips-modal-foot">
			<el-button type="success" @click="modalConfirm">确定</el-button>
			<el-button type="info" @click="hideModal">取消</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			modalTitle: { //提示框标题
				type: String,
				default: ''
			},
			modalContent: { //提示框内容
				type: String,
				default: ''
			},
		},
		data() {
			return {}
		},
		mounted() {
			let that = this;
			that.$nextTick(() => {

			})
		},
		methods: {
			//点击隐藏提示弹窗
			hideModal() {
				let that = this;
				that.$emit("hideModal");
			},
			//点击确认提示弹窗中的操作
			modalConfirm() {
				let that = this;
				that.$emit("modalConfirm");
			}
		},
	}
</script>

<style lang="scss">
	.tips-modal {
		.el-button {
			width: 235px;
			margin: 0 10px;
			font-weight: 400;
			color: #FCFCFC;
		}

		.tips-modal-head {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			background-color: #3F79F7;

			span {
				font-weight: 400;
				color: #FFFFFF;
			}

			.el-icon-close {
				color: #FFFFFF;
				cursor: pointer;
			}
		}

		.tips-modal-body {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: flex-start;

			span {
				font-weight: 400;
				color: #333333;
			}
		}

		.tips-modal-foot {
			background-color: #EDEDEB;
			padding: 16px 30px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
		}
	}

	@media screen and (min-width: 1024px) {
		.tips-modal {
			.el-button {
				font-size: 18px;
			}
		
			.tips-modal-head {
				padding: 10px 23px;
		
				span {
					font-size: 18px;
				}
		
				.el-icon-close {
					font-size: 18px;
				}
			}
		
			.tips-modal-body {
				padding: 16px 0;
		
				img {
					width: 26px;
					height: 26px;
					margin: 0 16px;
				}
		
				span {
					font-size: 18px;
				}
			}
		
			.tips-modal-foot {}
		}
	}

	@media screen and (min-width: 1280px) {}

	@media screen and (min-width: 1366px) {}

	@media screen and (min-width: 1440px) {}

	@media screen and (min-width: 1680px) {
		.tips-modal {
			.el-button {
				font-size: 24px;
			}

			.tips-modal-head {
				padding: 16px 40px;

				span {
					font-size: 32px;
				}

				.el-icon-close {
					font-size: 32px;
				}
			}

			.tips-modal-body {
				padding: 36px 0;

				img {
					width: 50px;
					height: 50px;
					margin: 0 43px 0 42px;
				}

				span {
					font-size: 24px;
				}
			}

			.tips-modal-foot {}
		}
	}

	@media screen and (min-width: 1920px) {}
</style>